import React, {forwardRef} from 'react';
import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from "../../../../components/bootstrap/Modal_v2";
import Button from "../../../../components/bootstrap/Button";


const EmptyModal = forwardRef((props, ref) => {
    return (
        <>
            <Modal
                id=""
                titleId=""
                isOpen={props?.isOpen}
                setIsOpen={props?.setIsOpen}
                isScrollable
                isBottomed
            >
                <ModalHeader setIsOpen={props?.setIsOpen}>
                    <ModalTitle>
                        Bottom Modal Title
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>
                        Modal Contents
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="info"
                        onClick={()=>{props?.setIsOpen(false)}}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
})

export default EmptyModal;
